<template>
    <b-overlay :show="loading" opacity="1" :class="loading ? 'p-2' : 'p-1'" rounded="sm">
        <div class="row">
            <div class="col-12 mb-1">
                <h3 class="font-weight-bolder">{{ $safe(json,'DriverFullName') }}</h3>
                <h4 class="text-secondary">{{$safe(json,'Day')}}</h4>
                <small class="text-muted d-block">{{ displayModeLabel }}</small>
            </div>
            <div class="col-12 mb-1">
                <tachograph-svg :rects="rects"></tachograph-svg>
            </div>
            <div class="col-12">
                <div class="border rounded p-1 pt-2 pb-75">
                    <app-timeline>
                        <app-timeline-item v-for="(item,index) in rects" :key="index" :time="item.Time" :title="item.activity" :variant="item.variant"/>
                    </app-timeline>
                </div>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BOverlay } from 'bootstrap-vue' 
import EmployeeOperationsApi from '@/api/employee-operations'
import TachographSvg from './TachographSvg.vue'
import AppTimeline from '@/@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@/@core/components/app-timeline/AppTimelineItem.vue'

export default {
    components:{
        BOverlay,
        TachographSvg,
        AppTimeline,
        AppTimelineItem
    },
    props:{
        detail:Object,
        displayMode:{
            type:String,
            default:"utc"
        }
    },
    data(){
        return {
            json:{},
            loading:false
        }
    },
    mounted(){
        this.getDayDetail()
    },
    watch:{
        detail:{
            deep:true,
            handler(){
                this.getDayDetail()
            }
        },
        displayMode(){
            this.getDayDetail()
        }
    },
    methods:{
        getDayDetail(){
            if(this.detail?.id){
                this.loading = true
                EmployeeOperationsApi.Tachograph.TachographJSON(
                    this.detail?.id,
                    this.displayMode,
                    this.detail?.DisplayDate || this.detail?.displayDate || null,
                ).then(res=>{
                    if(res.data.Success){
                        this.json = res.data.Data
                    }
                    this.loading = false
                }).catch(()=>{
                    this.loading = false
                })
            } else {
                this.json = {}
            }
        },
    },
    computed:{
        displayModeLabel(){
            return this.displayMode === 'utc_plus_3'
                ? 'Gosterim: UTC+3 (01.03.2026 ve sonrasi kayitlar)'
                : 'Gosterim: UTC'
        },
        rects(){
            let rects = []
            const items = this.json?.DailyTachographJsonModels || []
            if(items.length){
                for(let index = 0; index < items.length; index++){
                    let thisRect = items[index]
                    let nextRect = items[index + 1]
                    let x, fill, width, height, variant;
                    switch (thisRect.Activity) {
                        case 'Break':
                            fill = 'var(--danger)';
                            variant = 'danger';
                            height = 24;
                        break;
                        case 'Driving':
                            fill = 'var(--success)';
                            variant = "success"
                            height = 80;
                        break;
                        case 'Work':
                            fill = 'var(--warning)';
                            variant = "warning";
                            height = 55;
                        break;
                        case 'Available':
                            fill = 'var(--gray)';
                            variant = "dark"
                            height = 16;
                        break;
                        case 'NoData':
                            fill = '#d0d0d0';
                            variant = "light"
                            height = 16;
                        break;
                        default:
                            fill = 'var(--primary)';
                            variant = "primary"
                            height = 16;
                        break;
                    }
                    if(thisRect.Status == "0" && thisRect.Inserted == "False"){
                        fill = 'var(--primary)'
                        variant = "primary"
                        height = 16
                    }
                    let time = thisRect.Time.split(':')
                    x = (parseInt(time[0])*60) + parseInt(time[1])
                    if(nextRect != null){
                        let nextTime = nextRect.Time.split(':')
                        width = (parseInt(nextTime[0]) * 60) + parseInt(nextTime[1]) - x
                    }else {
                        width = 1439 - x
                    }
                    if(fill == 'red' && width < 15){
                        fill = 'var(--secondary)'
                        variant = "secondary"
                        height = 32
                    }
                    let thisRectObj = {x,fill,height,width,variant,time:thisRect.Time,activity:thisRect.Activity}
                    rects.push(thisRectObj)
                }
            }
            return rects
        }
    }
}
</script>

<style>

</style>
